<template>
	<div class="space-y-2">
		<dt class="flex">
			<IconCheck class="inline-block w-10 mt-2.5 text-mx-orange shrink-0" />
			<div class="ml-4">
				<span class="text-2xl font-semibold text-black">
					{{ title }}
				</span>
			</div>
		</dt>
		<dd
			v-if="content"
			class="text-gray-500 pl-14"
		>
			<span
				v-if="useHtml"
				v-html="content"
			/>
			<span v-else>
				{{ content }}
			</span>
		</dd>
	</div>
</template>

<script setup lang="ts">
const props = defineProps({
	title: {
		type: String,
		required: true
	},
	content: {
		type: String,
		default: ''
	},
	useHtml: {
		type: Boolean,
		default: false
	}
})

const { title, content, useHtml } = toRefs(props)
</script>
